import React from "react"
import { Link } from "gatsby"

const footer = props => {
  return (
    <div>
      <div class="footer-clean">
        <footer>
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-sm-4 col-md-3 item">
                <h4 class="mt-0">Quick Links</h4>
                <ul style={{ fontSize: "12px" }}>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/about-us">About Us</Link>
                  </li>
                  {/* <li>
                    <Link to="/">Business Coaching</Link>
                  </li>
                  <li>
                    <Link to="/">Individual and Personal Coaching</Link>
                  </li>
                  <li>
                    <Link to="/">Personal/Physical Training - Yoga</Link>
                  </li>
                  <li>
                    <Link to="/">The Millenial Project</Link>
                  </li> */}
                  <li>
                    <Link to="/what-we-do">What We Do</Link>
                  </li>
                  <li>
                    <Link to="/executive-and-leadership-coaching">
                      Leadership and Executive Coaching
                    </Link>
                  </li>
                  <li>
                    <Link to="/worksheet">Worksheet</Link>
                  </li>
                  <li>
                    <Link to="/reviews">Reviews</Link>
                  </li>
                  <li>
                    <a
                      href="http://www.themillennialproject.co/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      The Millennial Project
                    </a>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                  <li>
                    <Link to="/interviews-webinars">Interviews/Webinars/Articles</Link>
                  </li>
                </ul>
              </div>
              <div class="col-sm-4 col-md-3 item">
                <h4 class="mt-0">Risk Assessments and Development tools</h4>
                <ul style={{ fontSize: "12px" }}>
                  <li>
                    <Link to="/risk-assessment-and-development-tools/#corporate-cat-scan">
                      The Corporate Cat-Scan
                    </Link>
                  </li>
                  <li>
                    <Link to="/risk-assessment-and-development-tools/#blindspot">
                      Blind Spots Assessment
                    </Link>
                  </li>
                  <li>
                    <Link to="/risk-assessment-and-development-tools/#vision-traction-planner">
                      Vision/Traction Planner
                    </Link>
                  </li>
                </ul>
              </div>
              <div class="col-sm-4 col-md-3 item">
                <h4 class="mt-0">Company Info</h4>
                <ul style={{ fontSize: "12px" }}>
                  <li>
                    <div style={{ color: "#fff", opacity: 0.8 }}>
                      <i class="fa fa-phone mr-2" />
                      &nbsp;303.883.8001
                      <br />
                    </div>
                  </li>
                  <li>
                    <a
                      href="https://goo.gl/maps/DAHF6r9sLrKWHEHY8"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa fa-home mr-2" />
                      &nbsp;Denver, CO 80218
                    </a>
                  </li>
                  <li>
                    <a href="mailto:todd@managementinsight.co">
                      <i class="fa fa-envelope-o mr-2" />
                      &nbsp;todd@managementinsight.co
                    </a>
                  </li>
                </ul>
              </div>
              <div class="col-lg-3 item social">
                <a
                  href="https://www.facebook.com/toddasana.co/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class="fa fa-facebook-f" />
                </a>
                <a
                  href="https://www.linkedin.com/in/toddwheeler/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class="fa fa-linkedin" />
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
      <div class="copyright">
        <div class="container">
          <span>
            Management Insight © 2022 All rights reserved. Designed and powered
            by {``}
            <a
              href="https://webriq.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              WebriQ
            </a>
            .
          </span>
        </div>
      </div>
    </div>
  )
}

export default footer
